// extracted by mini-css-extract-plugin
export var icon = "icon-module--icon--1a7c5";